import { render, staticRenderFns } from "./LimitsCard.vue?vue&type=template&id=2d0302eb&scoped=true"
import script from "./LimitsCard.vue?vue&type=script&lang=js"
export * from "./LimitsCard.vue?vue&type=script&lang=js"
import style0 from "./LimitsCard.vue?vue&type=style&index=0&id=2d0302eb&prod&scoped=true&lang=css"
import style1 from "./LimitsCard.vue?vue&type=style&index=1&id=2d0302eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0302eb",
  null
  
)

export default component.exports